module.exports = __webpack_public_path__ + "static/media/burger-king.adac6167.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/clients/burger-king.png
// module id = 258
// module chunks = 0